import { Route, Routes } from 'react-router-dom'
import Home from './views/Home'
import Admin from './views/Admin'

const App = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/admin' element={<Admin />} />
    </Routes>
  )
}

export default App
